import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as categoryActions from './../../../../actions/categoryAction';
import Categories from './Categories';

const mapStateToProps = state => {
    return {
        categoryState: state.categoryReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListCategories: (filters) => dispatch(categoryActions.getListCategories(filters)),
        deleteCategoryDetail: (category, filters) => dispatch(categoryActions.deleteCategoryDetail(category, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Categories));
